import React from 'react';
import styled from 'styled-components';

const TestContainer = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const EnvTest = () => {
  return (
    <TestContainer>
      <h2>Environment Variables Test</h2>
      <p>This page shows the current environment variable values:</p>
      
      <div style={{ marginTop: '1rem', fontFamily: 'monospace', backgroundColor: '#f5f5f5', padding: '1rem', borderRadius: '4px' }}>
        <p><strong>REACT_APP_WOOCOMMERCE_CONSUMER_KEY:</strong> {process.env.REACT_APP_WOOCOMMERCE_CONSUMER_KEY || 'NOT SET'}</p>
        <p><strong>REACT_APP_WOOCOMMERCE_CONSUMER_SECRET:</strong> {process.env.REACT_APP_WOOCOMMERCE_CONSUMER_SECRET || 'NOT SET'}</p>
        <p><strong>REACT_APP_WOOCOMMERCE_API_URL:</strong> {process.env.REACT_APP_WOOCOMMERCE_API_URL || 'NOT SET'}</p>
      </div>
      
      <div style={{ marginTop: '1rem', padding: '1rem', backgroundColor: '#e3f2fd', borderRadius: '4px' }}>
        <h3>If environment variables show "NOT SET":</h3>
        <ol>
          <li>Stop your React development server (Ctrl+C)</li>
          <li>Restart it with: <code>npm start</code></li>
          <li>Refresh this page</li>
        </ol>
      </div>
    </TestContainer>
  );
};

export default EnvTest;